import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Sidebar } from "@/components/mixboard/Sidebar";
import { CanvasArea } from "@/components/mixboard/CanvasArea";
import { Inspector } from "@/components/mixboard/Inspector";
import { useMixboard } from "@/state/useMixboard";
import { MixboardAPI } from "@/lib/mixboard/api";

export default function MixboardPage() {
  const { id } = useParams();
  const setSession = useMixboard((s) => s.setSession);
  const setLayers = useMixboard((s) => s.setLayers);
  const setReferences = useMixboard((s) => s.setReferences);
  const setTypographyAssets = useMixboard((s) => s.setTypographyAssets);

  useEffect(() => {
    if (!id) return;
    (async () => {
      const data = await MixboardAPI.getSession(id);
      setSession(data);
      setLayers(data.layers || []);
      setReferences(data.references || []);
      setTypographyAssets(data.typography_assets || []);
    })();
  }, [id, setLayers, setReferences, setSession, setTypographyAssets]);

  return (
    <div className="flex h-full w-full">
      <Sidebar />
      <CanvasArea />
      <Inspector />
    </div>
  );
}
